import { Icon } from '@acpaas-ui/react-components';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import LinkButton from '../../components/core/LinkButton';
import { ROOT_PATH } from '../../constants/paths.constants';
import { BFF_HOST } from '../../constants/settings.constants';
import { authenticatedSelector } from '../../selectors/auth.selectors';

const host = BFF_HOST[process.env.REACT_APP_SPO_ENV] || '';

const LoginChooseMethod = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const authenticated = useSelector(authenticatedSelector);

  const onAprofielLogin = () => {
    window.location = `${host}/aprofiel/auth/login?fromUrl=${searchParams.get('fromUrl') || ''}&lng=nl`;
  };

  const onMprofielLogin = () => {
    window.location = `${host}/mprofiel/auth/login/mprofiel?fromUrl=${searchParams.get('fromUrl') || ''}&lng=nl`;
  };

  useEffect(() => {
    if (authenticated) {
      navigate(ROOT_PATH);
    }
  }, [navigate, authenticated]);

  return (
    <div className="spo-m-login-choose-method u-container u-margin-top-lg col-xs-12 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4">
      <h3 className="u-margin-bottom">Login</h3>
      <ul className="m-options-list u-margin-bottom">
        <li className="m-options-list__item">
          <LinkButton className="m-contact" onClick={onAprofielLogin}>
            <Icon name="ai-single-neutral" />
            <div className="m-contact__info">
              <p className="u-text-bold">Aanmelden als burger</p>
              <p className="small">Meld je aan met je A-profiel.</p>
            </div>
            <Icon className="u-margin-left-auto" name="ai-arrow-right-1" />
          </LinkButton>
        </li>
        <li className="m-options-list__item">
          <LinkButton className="m-contact" onClick={onMprofielLogin}>
            <i className="a-icon fa fa-building"></i>
            <div className="m-contact__info">
              <p className="u-text-bold">Aanmelden als medewerker</p>
              <p className="small">Meld je aan met je M-profiel.</p>
            </div>
            <Icon className="u-margin-left-auto" name="ai-arrow-right-1" />
          </LinkButton>
        </li>
      </ul>
    </div>
  );
};

export default LoginChooseMethod;
